export const getYearNow = () => new Date().getFullYear();
